import { KNOWLEDGE } from "@/lib/content";
import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Knowledge() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${BACKEND}/api/newsletter`, { email });
      toast.success("Subscribed. Fresh insights, no spam.");
      setEmail("");
    } catch { toast.error("Failed. Try again."); }
    setBusy(false);
  };
  return (
    <>
      <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-16">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          <div className="chapter-num">Knowledge Center</div>
          <h1 className="font-serif-display text-6xl md:text-8xl text-[var(--pta-navy)] mt-4 leading-[0.95]">Notes from<br /><em className="italic text-[var(--pta-gold)]">the practice.</em></h1>
        </div>
      </section>
      <section className="bg-[var(--pta-cream)] pb-24">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {KNOWLEDGE.map((k, i) => (
            <Link
              key={i}
              to={`/knowledge/${k.slug}`}
              data-testid={`knowledge-${i}`}
              className="pta-card border hairline bg-[var(--pta-cream)] p-8 group block"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-[var(--pta-gold)] border hairline-gold px-2 py-1">{k.tag}</span>
                <ArrowUpRight size={16} weight="bold" className="text-[var(--pta-navy)] group-hover:text-[var(--pta-gold)]" />
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl text-[var(--pta-navy)] mt-6 leading-tight">{k.title}</h3>
              {k.excerpt && <p className="mt-4 text-sm text-[var(--pta-ink)]/65 leading-relaxed line-clamp-3">{k.excerpt}</p>}
              <div className="mt-6 flex items-center justify-between font-mono-fine text-[10px] tracking-[0.22em] uppercase text-[var(--pta-ink)]/50">
                <span>{k.date}</span><span>{k.read}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <section className="section-dark py-20">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <div className="chapter-num">Newsletter</div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-[var(--pta-cream)] mt-4">Weekly finance insights — for people who read the footnotes.</h2>
          <form onSubmit={submit} className="mt-8 flex flex-col md:flex-row gap-3 max-w-xl mx-auto">
            <input data-testid="newsletter-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="your@company.com" className="flex-1 px-4 py-3 bg-transparent border text-[var(--pta-cream)] placeholder-white/40 focus:outline-none" style={{ borderColor: 'rgba(212,175,55,0.5)' }} />
            <button data-testid="newsletter-submit" disabled={busy} className="btn-pta-gold">{busy?"…":"Subscribe"}</button>
          </form>
        </div>
      </section>
    </>
  );
}
